exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main:hover {\n  background-color: #0C6EFD;\n}", ""]);

// exports
